import React from "react";
import { observer } from "mobx-react";
import ibsStore from '../../../Stores/IbsSurveyStore';
import store from '../../../Stores/SurveyStore';
import SharedStore from '../../../Stores/SharedStore';
import 'bootstrap/dist/css/bootstrap.css';
import 'handsontable/dist/handsontable.full.css';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { addNewMandate, triggerMandateOnlyMode, showHideOptionalMandateColumns } from "../../../../ibsHelper";
import { Switch } from "@progress/kendo-react-inputs";
import { exportMandateData } from "../../../../Helpers/ExportTableDataHelper";
import { checkIfAnalyst } from "../../../../Services/IBS/IbsService";
import { toggleMandateDefaults } from "../../../../Helpers/DefaultsHelper";

export function MandateTableButtons(hotTableInstance, referenceToTable, props) {
    return (
        <div className="MandateMenu">
            <br />
            <div className="mandateLevelButtons">
                {(ibsStore.checkMandateLevel != 1) &&
                    <button onClick={e => showAddAssetRowModal(props.tableName)} type="btn btn-add-row" className="btn btn-add-row">Add New Asset Class/Style</button>
                }
                {(ibsStore.checkMandateLevel != 0) &&
                    <button onClick={e => addNewMandate()} type="button" className="btn btn-add-row noFloat">Add New Mandate</button>
                }
                {
                    (false) ?
                        <button onClick={e => triggerMandateOnlyMode()} type="button" className="btn btn-add-row">{ibsStore.mandateOnlyView ? "Show Mandates & AC" : "Show Mandates Only"}</button>
                        : null
                }
                {(checkIfAnalyst() && false) &&
                    < button onClick={e => showHideOptionalMandateColumns()} type="button" className="btn btn-add-row">{ibsStore.showOptionalMandateColumns ? "Hide Optional Columns" : "Show Optional Columns"}</button>
                }
                <div className="filterAndSearchMandates">
                    <i className='fas fa-filter fa-2x filterIcon'></i>
                    <DropDownList
                        className={"surveySelectFilter"}
                        onChange={onChangeCategory}
                        data={["All", "Equities", "Bonds", "Real Assets", "Multi-Asset Strategies", "Private Debt", "Private Equity", "Derivatives/Overlays"]}
                        value={ibsStore.mandateCategoryToRender}
                    />
                    <i className="fas fa-2x fa-override fa-search searchIcon"></i>
                    <input
                        className={"searchInput"}
                        id={"searchInput2"}
                        onChange={searchAttempt}
                    />
                    <div id="mandateButtonsRight">
                        {(ibsStore.currentSurvey.DataYear === SharedStore.currentDataYear || checkIfAnalyst()) &&
                            (ibsStore.mandateData.length > 0 || ibsStore.allTableResponses["combinedAssets"].length > 0) && (
                                <div id="toggleDefaults">
                                    <Switch defaultChecked={ibsStore.isMandateDefaultsShown ? true : false}
                                        checked={ibsStore.isMandateDefaultsShown ? true : false}
                                        onChange={e => { toggleMandateDefaults(); }} />
                                    <span> Show Imputed Costs</span>
                                </div>
                            )}

                        <i className="fa fa-download fa-2x downloadButton" aria-hidden="true" title="Export Data"
                            onClick={e => exportMandateData(hotTableInstance, referenceToTable, props)}></i>

                        {(ibsStore.currentSurvey.DataYear === SharedStore.currentDataYear || checkIfAnalyst()) && (
                            <i className="fa fa-2x fa-solid fa-gear customizeTableBtn" title="Customize table"
                                onClick={e => { ibsStore.showAssetConfigureModal = ibsStore.showCustomiseTableOpts = ibsStore.showCustomiseTableOpts2 = true; }}></i>
                        )}
                    </div>

                </div>
            </div>

        </div>
    );

}

const showAddAssetRowModal = (tableName) => {
    store.showAddRowModal = true;
    store.rowDetails.TableName = tableName
    store.showAssetOptions = true;

}
const onChangeCategory = (e) => {
    //normalize select input // if ibs select, save value as an integer
    ibsStore.mandateCategoryToRender = e.target.value;
}

let searchTimer = null;
const searchAttempt = async function (e) {
    let toSearchFor = e.target.value === "" ? null : e.target.value;
    if (searchTimer != null) {
        clearTimeout(searchTimer);
    }
    searchTimer = setTimeout(function () { searchForItems(toSearchFor) }, 1000);

}

const searchForItems = async function (value) {
    ibsStore.mandateSearchToRender = value;
}

